import { type GroupIn, Op, SortInFn } from "@api/generated/model";
import { z } from "zod";

// A link is user input: validate the shape before handing it to the editable query model.
const condition = z.object({ field: z.string(), op: z.enum(Op), value: z.unknown().optional(), value2: z.unknown().optional() });
function group(depth: number): z.ZodType<GroupIn> {
  return z.object({
    op: z.enum(["and", "or"]).optional(),
    items: z
      .array(depth > 0 ? z.union([condition, group(depth - 1)]) : condition)
      .max(200)
      .optional(),
  });
}
export const querySnapshot = z.object({
  columns: z.array(z.string()).max(400).optional(),
  where: group(6).optional(),
  scope: z
    .object({ years: z.array(z.number().int()).optional(), sites: z.array(z.string()).optional(), trials: z.array(z.string()).optional() })
    .optional(),
  distinct: z.boolean().optional(),
  line_set: z
    .object({
      trials: z
        .array(z.object({ ev: z.number().int(), kis: z.string() }))
        .max(50)
        .optional(),
      lines: z
        .array(z.object({ paz: z.number().int(), sid: z.number().int() }))
        .max(20000)
        .optional(),
      query: z.number().int().nullable().optional(),
      group: z.boolean().optional(),
    })
    .nullable()
    .optional(),
  sort: z
    .array(
      z.object({
        field: z.string(),
        desc: z.boolean().optional(),
        fn: z.enum(SortInFn).optional(),
        length: z.number().int().nullable().optional(),
        pos: z.number().int().nullable().optional(),
        pattern: z.string().nullable().optional(),
      }),
    )
    .max(400)
    .optional(),
});
